export const dialPadItems: { title: string; subtitle?: string }[] = [
  { title: '1' },
  { title: '2', subtitle: 'ABC' },
  { title: '3', subtitle: 'DEF' },
  { title: '4', subtitle: 'GHI' },
  { title: '5', subtitle: 'JKL' },
  { title: '6', subtitle: 'MNO' },
  { title: '7', subtitle: 'PQRS' },
  { title: '8', subtitle: 'TUV' },
  { title: '9', subtitle: 'WXYZ' },
  { title: '*', subtitle: ',' },
  { title: '0', subtitle: '+' },
  { title: '#' },
]
